/**
 * @generated SignedSource<<e5566771202443dadd0fdc53745ae60a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StreamAccessType = "full" | "partial" | "shared";
export type SummaryModalStreamInfoQuery$variables = {
  currentStreamId: string;
  selectedStreamId: string;
};
export type SummaryModalStreamInfoQuery$data = {
  readonly currentStream: {
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly id: string;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly isExternal: boolean;
      };
    }>;
    readonly viewerNotestreamuser: {
      readonly id: string;
    } | null;
  } | null;
  readonly selectedStream: {
    readonly displayName: string;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly id: string;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
      };
    }>;
    readonly type: NoteStreamType;
    readonly viewerNotestreamuser: {
      readonly accessType: StreamAccessType;
    } | null;
  } | null;
  readonly viewer: {
    readonly account: {
      readonly allowExternalInviting: boolean | null;
    };
  };
};
export type SummaryModalStreamInfoQuery = {
  response: SummaryModalStreamInfoQuery$data;
  variables: SummaryModalStreamInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentStreamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedStreamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExternalInviting",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "currentStreamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "viewerNotestreamuser",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "selectedStreamId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SummaryModalStreamInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "currentStream",
        "args": (v2/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "selectedStream",
        "args": (v8/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamUser",
            "kind": "LinkedField",
            "name": "viewerNotestreamuser",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SummaryModalStreamInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "currentStream",
        "args": (v2/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v7/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "selectedStream",
        "args": (v8/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamUser",
            "kind": "LinkedField",
            "name": "viewerNotestreamuser",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1088421f538546d62a686415e3911c30",
    "id": null,
    "metadata": {},
    "name": "SummaryModalStreamInfoQuery",
    "operationKind": "query",
    "text": "query SummaryModalStreamInfoQuery(\n  $currentStreamId: ID!\n  $selectedStreamId: ID!\n) {\n  viewer {\n    account {\n      allowExternalInviting\n      id\n    }\n    id\n  }\n  currentStream: noteStream(id: $currentStreamId) {\n    viewerNotestreamuser {\n      id\n    }\n    notestreamusers {\n      id\n      accessType\n      user {\n        id\n        fullName\n        isExternal\n      }\n    }\n    id\n  }\n  selectedStream: noteStream(id: $selectedStreamId) {\n    type\n    displayName\n    viewerNotestreamuser {\n      accessType\n      id\n    }\n    notestreamusers {\n      id\n      accessType\n      user {\n        id\n        fullName\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c679bfdca631396833b561d129c76f2";

export default node;
